import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import { CodeBlock, BlockType, SettingType } from '@appblocks/codegeneration/types';

export default class Tibbit_57 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_57';
        this.name = 'Tibbit 57';
        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/tibbits/tbt57/tbt57_common.tbh',
            'libraries/tibbits/tbt57/tbt57_common.tbs',
            'libraries/tibbits/tbt57/tbt57_sled.tbh',
            'libraries/tibbits/tbt57/tbt57_sled.tbs',
            'RGBW_Driver_top_bitmap.bin',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                required: true,
                default: '',
            },
            {
                id: 'USESSI',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                default: 'YES',
                options: [
                    {
                        name: 'I2C mode',
                        value: 'YES',
                    },
                    {
                        name: 'Direct I/O (bit-banging)',
                        value: 'NO',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const socket = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id);

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 57 on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    select case tbt57_sled_init(${this.getSettingValue('NAME')}_CHANNEL,${this.getSettingValue('NAME')}_CS,${this.getSettingValue('NAME')}_CLK,${this.getSettingValue('NAME')}_MOSI,${this.getSettingValue('NAME')}_MISO)
    case TBT57_FILE_NOT_ATTACHED:
        sys.debugprint("FPGA configuration file not attached or empty. Execution halted.\\r\\n")
        goto loop1

    case TBT57_INIT_FAILURE:
        sys.debugprint("Tibbit initialization failure. Execution halted.\\r\\n")
        goto loop1

    case TBT57_NO_SSI_AVAILABLE:
        sys.debugprint("SSI channel could not be allocated. Execution halted.\\r\\n")
        pat.play("R~",PL_PAT_CANINT)
loop1:  while 1
        wend
    end select
    '-----------------------------------------------------------------
        `,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${this.getSettingValue('NAME')}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${this.getSettingValue('NAME')}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${this.getSettingValue('NAME')}_CS=${socket?.pins[0]}
const ${this.getSettingValue('NAME')}_CLK=${socket?.pins[1]}
const ${this.getSettingValue('NAME')}_MOSI=${socket?.pins[0]}
const ${this.getSettingValue('NAME')}_MISO=${socket?.pins[1]}`,
        });


        return blocks;
    }
}
